export class RegionFilter {
    regionFilterId: number;
    regions: string;
    username: string;

    constructor() {}
}
